import FJTextBaseEditVideoRight from '../view/FJTextBaseEditVideoRight';
import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import FJActionRightTextBaseEditing from '../../../../redux/action/textBasedEditing/FJActionRightTextBaseEditing.js';

const FJTextBaseEditVideoRightContainer = () => {
    const dispatch = useDispatch();

    const setVideoCanvas = useCallback(
        viewCanvas => {
            dispatch(FJActionRightTextBaseEditing.setVideoCanvasAction(viewCanvas));
        },
        [dispatch],
    );

    const resize = useCallback(() => {
        dispatch(FJActionRightTextBaseEditing.resizeAction());
    }, [dispatch]);

    const pause = useCallback(() => {
        dispatch(FJActionRightTextBaseEditing.pauseAction());
    }, [dispatch]);

    return <FJTextBaseEditVideoRight setVideoCanvas={setVideoCanvas} pause={pause} resize={resize} />;
};

export default FJTextBaseEditVideoRightContainer;
